export { resolveReferencePath } from '../helpers/resolve-reference-path.js';
export { bundle, extensions, isLocalRef, prefixInternalRef, prefixInternalRefRecursive, resolveAndCopyReferences, } from './bundle.js';
